// extracted by mini-css-extract-plugin
export var simpleQuote = "styles-module--simpleQuote--I4SAE";
export var simpleQuoteText = "styles-module--simpleQuoteText--WlSNq";
export var backAndForthRight = "styles-module--backAndForthRight--C01KF";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--0s+Tg";
export var animateBg = "styles-module--animateBg--mAIEC";